import http from "./http"

class wpHttpClient extends http {
  constructor() {
    super(process.env.GATSBY_WP_API_URL)
  }
}

export default new wpHttpClient()
